export const validateStringField = (value: string) =>
  !value && "Campo requerido.";
